/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Headers_0Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_headers_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Headers_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_headers_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Headers_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Headers_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_3_table_headers_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Headers_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_3_Table_Headers_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_headers_0(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_3_table_headers_0(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_3_table_headers_0 as "gc.search_guides.gridcraft_excel_compatibility.sections.3.table.headers.0" }